
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		disabled: {
			type: Boolean,
			required: false,
		},
		error: {
			type: String,
			default: ""
		},
		errors: {
			type: Array,
			default: () => [],
		},
		hasError: {
			type: Boolean,
			required: false
		},
		showMessage: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
});
